module.exports = __webpack_public_path__ + "img/047-laundry.ef1a74da.svg";